module.exports = __webpack_public_path__ + "static/media/empty.78469802.svg";